exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td ,th  {\r\n    text-align: center;\r\n    vertical-align: middle !important;\r\n}\r\n.odd {\r\n    vertical-align: middle;\r\n}\r\ntd{\r\n    vertical-align: middle\r\n}\r\n\r\nbody{\r\n    height: 100vh;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/users/users.component.css
// module id = ../../../../../src/app/users/users.component.css
// module chunks = main